


import React from "react";
import emailjs from 'emailjs-com'
import styled from "styled-components";
import { BrandLogo } from "../../components/brandLogo";
import { Button } from "../../components/button";

import FarmingImg from "../../images/cancelamento.png";
import { Marginer } from "../../components/marginer";
import { deviceSize } from "../../components/responsive";
import { useMediaQuery } from "react-responsive";

const SpecialistAdContainer = styled.div`
  width: 100%;
  height: 990px;
  display: flex;
  background: rgb(254,254,254);
background: linear-gradient(90deg, rgba(254,254,254,1) 7%, rgba(232,233,227,1) 83%);
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    flex-direction: column-reverse;
  }
`;

const SloganContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 5em;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    align-items: center;
    margin: 0;
  }
`;

const Slogan = styled.h2`
  margin: 0;
  font-size: 24px;
  color: #fff;
  font-weight: 700;
  line-height: 1.3;
  text-align: start;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 20px;
  }
`;

const StandoutImage = styled.div`
  width: 35em;
  height: 29em;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 18em;
    height: 14em;
  }
`;

const SloganS = styled.div`

padding:17px;
font-size:44px;
color:#0000cc;
`


const SloganN = styled.div`
padding:17px;
font-size:15px;
color:#0000cc;
margin-bottom:-25px;



`


const SloganV = styled.div`
padding:17px;
font-size:15px;
color:#0000cc;
margin-bottom:-25px;



`


const SloganR = styled.div`
padding:17px;
font-size:15px;
color:#0000cc;




`

const ButtonNice= styled.div`
background-color:#0000cc;
padding:13px;
margin-left:17px;
width:350px;
border-radius:36px;
color:#ffffff;
font-weight:bold;



`

const LabelS = styled.div`
color:#ffffff;
font-weight:bold;
margin-bottom:35px;
margin: 0 auto;
align-items:center;
float:left;
padding:12px;
background-color:#0000cc;
border-radius:15px;






`

const ImnputS = styled.div`
.Input{

width:100%;
border-radius:36px;
border:none;
padding:16px;
font-weight:bold;
color:#0000cc;
margin-bottom:20px;
margin-top:14px;
}
.textarea{

  padding:20px;
  width:100%;
  border-radius:15px;
  border:none;
  background-color:#f2f2f2;
  
  }
  .SELECT__{


    border:none;
    padding:16px;
    width:100%;
    border-radius:16px;
    background-color:#0000cc;
    color:#ffffff;
    margin-bottom:16px;
    text-align:center;
  }

.botao__{

width:100%;
background-color:#0000cc;
color:#ffffff;
text-align:center;
align-items:center
margin:0 auto;
border:none;
border-radius:36px;
margin-top:25px;
padding:18px;

}
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 2px 30px 2px 2px;
    border: none;
}

`

const TituloT = styled.div`

margin-top:50px;
margin-bottom:30px;
.Titulo{

color:#0000cc;
font-weight:bold;
font-size:29px;

}

`

const Nomes = styled.label`

color:red;

`

const DivS = styled.div`

padding:30px;


`
const message = () => {
  window.alert('Recebemos sua solicitação de cancelamento e estamos trabalhando para resolve-la... ');
  setInterval(function() {
    window.location.reload();
  }, 2000); 
  
 }
export function Email(props) {
  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });
  function sendEmail(e){
    e.preventDefault();


    emailjs.sendForm('service_sl4kue7',
    'template_glftxeo',
     e.target,
     "user_pVQ2xVKY8QfEaeEf1FJYs")
     .then(res=>{
            console.log(res);

     }).catch(err=> console.log(err));
  }


  return (
    <SpecialistAdContainer>
  <DivS>

  <TituloT><h1 className="Titulo"> Cancelamento P.P.A - proteção veicular automotiva</h1></TituloT>
  <form onSubmit={sendEmail}>
    
    
    <ImnputS><input className="Input" required type="text" placeholder="Seu Nome Completo"name="associado" /></ImnputS>
    
    <ImnputS><input className="Input" required type="text" placeholder="Placa do veículo" name="placa" /></ImnputS>
    
    <ImnputS><input className="Input" required type="text" placeholder="Marca modelo do Veículo" name="veiculo" /></ImnputS>
    
    <ImnputS><input className="Input" required type="number" placeholder="Tel/Whatsapp" name="Whatsapp" /></ImnputS>
   
    <ImnputS><input className="Input" required type="email" placeholder="Seu Email" name="email" /></ImnputS>
    
    <ImnputS><select required className="SELECT__"id="cancelamento" name="cancelamento">
    <option value="você não escolheu o motivo">Escolha o Motivo do cancelamento</option>
    <option value="Venda do veículo">Venda do Veículo</option>
    <option value="Contenção de despesas">Contenção de despesas</option>
    <option value="Devolução do veículo">Devolução do veículo</option>
    <option value="insatisfação com serviços prestados">insatisfação com serviços prestados</option>
    <option value="Proposta de outra seguradora/associadora">Proposta de outra seguradora/associadora</option>
    <option value="Motivos pessoais">Motivos pessoais</option>
  
  </select></ImnputS>

    
    <ImnputS> <textarea required className="textarea"name="motivo" placeholder="Descreva o motivo" rows="3" /></ImnputS>

    <ImnputS><input onClick={message} className="botao__"type="submit" value="Enviar Cancelamento"/></ImnputS>


  </form>
</DivS>
    </SpecialistAdContainer>
  );
}

